import { Money, formatMoney, isValidMoney } from '@betterment/core';
import {
  moneyTradeEstimateCopy,
  sharesTradeEstimateCopy,
} from '@betterment/shared-components/src/utils/tradeEstimateHelpers';

import { SaleDetailsRow } from './SaleDetailsRow';
import { AmountChoice, OrderUnit } from './types';

import { pluralize } from '../../../utils/strings/strings';

type ReviewSecurityAmountProps = {
  pricePerShare: Money;
  willSellAll?: boolean;
} & AmountChoice;

export const pluralizeWithoutRoundingShares = (count: number, noun: string, suffix?: string, singularSuffix?: string) =>
  pluralize(count, noun, suffix, singularSuffix, { maximumFractionDigits: 6 });

export const ReviewSecurityAmount: React.FC<ReviewSecurityAmountProps> = props => {
  const { pricePerShare, amount, unit, willSellAll } = props;

  const isAmountMissing = !amount || (isValidMoney(amount) && amount.cents === 0);
  const isPricePerShareMissing = !pricePerShare || pricePerShare.cents === 0;

  if (isAmountMissing || isPricePerShareMissing || !unit) {
    return <SaleDetailsRow.Value>—</SaleDetailsRow.Value>;
  }

  return (
    <>
      {unit === OrderUnit.Dollars && (
        <SaleDetailsRow.Value>
          <SaleDetailsRow.Value.Primary>{formatMoney(amount)}</SaleDetailsRow.Value.Primary>
          <SaleDetailsRow.Value.Secondary>
            {sharesTradeEstimateCopy(amount, pricePerShare)}
          </SaleDetailsRow.Value.Secondary>
        </SaleDetailsRow.Value>
      )}
      {unit === OrderUnit.Shares && (
        <SaleDetailsRow.Value>
          <SaleDetailsRow.Value.Primary>
            {willSellAll && 'All '}
            {pluralizeWithoutRoundingShares(amount, 'share')}
          </SaleDetailsRow.Value.Primary>
          <SaleDetailsRow.Value.Secondary>
            {moneyTradeEstimateCopy(amount, pricePerShare)}
          </SaleDetailsRow.Value.Secondary>
        </SaleDetailsRow.Value>
      )}
    </>
  );
};
